// @ts-check
import axios from 'axios';
import config from '../constants/config';

const usersAxios = axios.create();
const usersService = {};

/**
 * Get list of users
 * @param {import('../../../types/common').PaginationOptions} params
 * @returns
 */
usersService.getUsers = (params) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/users/`;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return usersAxios.get(url, { headers, params });
};

/**
 * Update user status
 * @param {import('../../../types/common').ObjectIdType} userId
 * @param {boolean} newStatus
 * @returns
 */
usersService.updateUserStatus = (userId, newStatus) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/users/${userId}/status`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const data = {
    status: newStatus,
  };

  return usersAxios.patch(url, data, { headers });
};

export default usersService;
